module.exports = __webpack_public_path__ + "static/media/Harry-Potter-Logo.e27d1012.png";